import _extends from "@babel/runtime/helpers/extends";
import { useContext } from 'react';
export var useMergeProps = function useMergeProps(props, groupContext) {
  var _useContext = useContext(groupContext),
      disabled = _useContext.disabled,
      shape = _useContext.shape,
      layout = _useContext.layout,
      icons = _useContext.icons,
      value = _useContext.value,
      _onChange = _useContext.onChange,
      isGroup = _useContext.isGroup;

  if (!isGroup) return props;
  return _extends({
    disabled: disabled,
    shape: shape,
    layout: layout,
    icons: icons
  }, props, {
    // 在Group内checkbox的选中状态由GroupValue决定
    // The checked state of the checkbox in the Group is determined by the GroupValue
    checked: value.indexOf(props.value) > -1,
    onChange: function onChange(checked, val, e) {
      _onChange(checked, val, e);

      props.onChange && props.onChange(checked, val, e);
    }
  });
};